import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface ImageCardSkeletonLoaderProps {
    count?: number;
}

export const ImageCardSkeletonLoader = ({ count = 4 }: ImageCardSkeletonLoaderProps) => {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <SkeletonCard key={index}>
                    <SkeletonImagePreview>
                        <Skeleton width="100%" height="100%" className="image-skeleton" />
                    </SkeletonImagePreview>
                    <SkeletonCardContent>
                        <Skeleton width="80%" height={20} className="title-skeleton" />
                        <SkeletonCardActions>
                            <Skeleton width="100%" height={36} className="button-skeleton" />
                            <Skeleton width="100%" height={36} className="button-skeleton" />
                        </SkeletonCardActions>
                    </SkeletonCardContent>
                </SkeletonCard>
            ))}
        </>
    );
};

const SkeletonCard = styled.div`
    border: 1px solid #dceaff;
    border-radius: 8px;
    background-color: #edf4fd99;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;

    .react-loading-skeleton {
        --base-color: #b7bdbe2b;
        --highlight-color: #f5f5f58f;
    }
`;

const SkeletonImagePreview = styled.div`
    width: 100%;
    height: 180px;
    background-color: #f3f4f6;
`;

const SkeletonCardContent = styled.div`
    padding: 18px 16px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .title-skeleton {
        margin-bottom: 12px;
    }
`;

const SkeletonCardActions = styled.div`
    display: flex;
    gap: 8px;
    margin-top: auto;

    .button-skeleton {
        flex: 1;
        border-radius: 6px;
    }
`;